<template>
  <div class="loader-container">
    <img class="loader" src="@/assets/img/misc/loader.svg" alt="Loading animation" />
  </div>
</template>
